import '../sass/main.scss'
import './components/full-height.js'
import './components/hero-images-and-header.js'
import {handleMobileMenu} from './components/mobile-menu.js'
import {createObserver as createCounterUpObserver} from './components/counter-up-in-view-observer'
import {createObserver as createOnScrollAnimateScaleObserver} from './components/on-scroll-animate-scale-observer'
import {createObserver as createInViewportAnimateObserver} from './components/in-viewport-animate-observer'
import {createObserver as createTestimonialsObserver} from './components/testimonials.js'
import {createObserver as createPartnersObserver} from './components/partners'
import './components/video-player'
import {renderDevs} from './utils/devs'

if (window.location.hash) {
    const languageItems = document.querySelectorAll('.Layout--NavItem.lang .Layout--NavItemSub a')
    if (languageItems.length) {
        for (let langItem of languageItems) {
            langItem.href += window.location.hash
        }
    }
}

let lastHeaderHeight = 0
const htmlAttributesObserver = new MutationObserver(function(event)  {
    for (let i = 0; i < event.length; ++i) {
        const attributeName = event[i].attributeName

        const headerHeight = parseInt(event[i].target.dataset.headerHeight || 70, 10)
        if (lastHeaderHeight !== headerHeight) {
            if (attributeName === 'data-header-height') {
                createCounterUpObserver(headerHeight)
                createOnScrollAnimateScaleObserver(headerHeight)
                createInViewportAnimateObserver(headerHeight)
                createTestimonialsObserver(headerHeight)
            }

            lastHeaderHeight = headerHeight
        }

        if (attributeName === 'data-header-height' || attributeName === 'data-width') {
            createPartnersObserver(headerHeight)
        }
    }
});
htmlAttributesObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['data-header-height', 'data-width'] })

requestAnimationFrame(() => {
    const anchors = document.querySelectorAll('[data-anchor]')
    for (let anchor of anchors) {
        anchor.addEventListener('click', function(e) {
            let isSamePage = true
            let linkUrl = {}
            if (this.href) {
                e.preventDefault();
                linkUrl = new URL(this.href);

                isSamePage = (
                    linkUrl.origin === location.origin &&
                    linkUrl.pathname === location.pathname
                );
            }

            const mobileMenuToggle = document.getElementsByClassName('Layout--MenuToggle')?.[0]
            if (mobileMenuToggle && mobileMenuToggle.ariaExpanded === 'true') {
                handleMobileMenu(
                    mobileMenuToggle,
                    document.getElementById(mobileMenuToggle.dataset.targetId)
                )(e)
            }

            const targetId = String(this.getAttribute('data-anchor')).replaceAll('#', '')
            if (isSamePage) {
                //history.pushState(null, '', `${targetId}`);
                if (location.hash === '#' + targetId) {
                    const targetElement = document.getElementById(targetId)
                    if (targetElement) {
                        targetElement.scrollIntoView({ behavior: 'smooth' });
                    }
                } else {
                    location.hash = targetId
                }
            } else if (this.href) {
                location.href = this.href + '#' + targetId
            }
        })
    }


    let headerHeight = parseInt(document.documentElement.dataset.headerHeight, 10)
    if (isNaN(headerHeight)) {
        headerHeight = document.querySelector('header')?.clientHeight ?? 70;
        if (headerHeight > 120)
            headerHeight = 70
    }
    createCounterUpObserver(headerHeight)
    createOnScrollAnimateScaleObserver(headerHeight)
    createInViewportAnimateObserver(headerHeight)
    createTestimonialsObserver(headerHeight)
    createPartnersObserver(headerHeight)

    if (window.scrollX !== 0) {
        window.scrollTo(0, window.scrollY)
    }

    // Chatbase integration
    window.chatbaseConfig = {
        chatbotId: 'ejkfYaxalbNtmOwzglTpt',
    }

    const script = document.createElement('script');
    script.src = 'https://www.chatbase.co/embed.min.js';
    script.id = 'ejkfYaxalbNtmOwzglTpt';
    script.defer = true;
    document.body.appendChild(script);

    const nytsys = document.createElement('script')
    nytsys.src = 'https://plugin.nytsys.com/api/site/a2c0a209-c0e4-489b-8811-9427a611c27c/nytsys.min.js'
    nytsys.defer = true
    document.body.appendChild(nytsys)
})

renderDevs()
